import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/api/client";
import Layout from "@/components/Layout";
import Modal from "@/components/Modal";
import { euro, fmtDate } from "@/lib/format";
import { toast } from "sonner";
import { IDS } from "@/constants/testIds";

const emptyO = {
  number: "",
  date: new Date().toISOString().slice(0, 10),
  customer_id: "",
  customer_name: "",
  status: "Da preparare",
  total: 0,
  note: "",
  items: [],
};

export default function Ordini() {
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(emptyO);
  const [editingId, setEditingId] = useState(null);

  const load = async () => {
    const [o, c] = await Promise.all([api.get("/orders"), api.get("/customers")]);
    setOrders(o.data); setCustomers(c.data);
  };
  useEffect(() => { load(); }, []);

  const openNew = () => {
    const year = new Date().getFullYear();
    setForm({ ...emptyO, number: `ORD-${year}-${String(orders.length + 1).padStart(4, "0")}` });
    setEditingId(null); setModal(true);
  };
  const openEdit = (o) => { setForm({ ...emptyO, ...o }); setEditingId(o.id); setModal(true); };
  const save = async () => {
    if (!form.customer_name.trim() && !form.customer_id) return toast.error("Seleziona o inserisci il cliente");
    try {
      const cn = form.customer_id ? customers.find((c) => c.id === form.customer_id)?.name || form.customer_name : form.customer_name;
      const body = { ...form, customer_name: cn, total: +form.total || 0 };
      if (editingId) await api.put(`/orders/${editingId}`, body);
      else await api.post("/orders", body);
      toast.success("Ordine salvato"); setModal(false); load();
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  const del = async (id) => {
    if (!window.confirm("Eliminare l'ordine?")) return;
    await api.delete(`/orders/${id}`); toast.success("Eliminato"); load();
  };

  const statusPill = (s) =>
    s === "Completato" ? "ok" : s === "Annullato" ? "danger" : "warn";

  return (
    <Layout topbarActions={
      <button className="btn accent" onClick={openNew} data-testid={IDS.newOrderBtn}>
        <i className="fa-solid fa-plus" /> Nuovo ordine
      </button>
    }>
      <div className="section-title">
        <div><h2>Ordini</h2><p>Gestione ordini cliente con collegamento al cliente in anagrafica.</p></div>
      </div>
      <div className="panel">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Numero</th><th>Data</th><th>Cliente</th><th>Stato</th><th>Totale</th><th>Note</th><th></th></tr></thead>
            <tbody data-testid="orders-table-body">
              {orders.length ? orders.map((o) => (
                <tr key={o.id}>
                  <td><b>{o.number}</b></td>
                  <td>{fmtDate(o.date)}</td>
                  <td>{o.customer_name}</td>
                  <td><span className={`pill ${statusPill(o.status)}`}>{o.status}</span></td>
                  <td>{euro(o.total)}</td>
                  <td>{o.note || "—"}</td>
                  <td style={{ display: "flex", gap: 6 }}>
                    <button className="btn small" onClick={() => openEdit(o)}><i className="fa-solid fa-pen" /></button>
                    <button className="btn small danger" onClick={() => del(o.id)}><i className="fa-solid fa-trash" /></button>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={7} className="empty">Nessun ordine inserito.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal open={modal} title={editingId ? "Modifica ordine" : "Nuovo ordine"} onClose={() => setModal(false)} onSave={save}>
        <div className="form-grid">
          <div className="field"><label>Numero ordine</label><input value={form.number} onChange={(e) => setForm({ ...form, number: e.target.value })} /></div>
          <div className="field"><label>Data</label><input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></div>
          <div className="field"><label>Cliente da rubrica</label>
            <select value={form.customer_id} onChange={(e) => {
              const c = customers.find((x) => x.id === e.target.value);
              setForm({ ...form, customer_id: e.target.value, customer_name: c ? c.name : form.customer_name });
            }}>
              <option value="">— nessuno / manuale —</option>
              {customers.map((c) => <option key={c.id} value={c.id}>{c.name}{c.team ? ` (${c.team})` : ""}</option>)}
            </select>
          </div>
          <div className="field"><label>Nome cliente (o manuale) *</label><input value={form.customer_name} onChange={(e) => setForm({ ...form, customer_name: e.target.value })} data-testid="o-customer" /></div>
          <div className="field"><label>Stato</label>
            <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
              <option>Da preparare</option><option>In lavorazione</option><option>Completato</option><option>Annullato</option>
            </select>
          </div>
          <div className="field"><label>Totale</label><input type="number" step="0.01" min="0" value={form.total} onChange={(e) => setForm({ ...form, total: e.target.value })} /></div>
          <div className="field full"><label>Note / riepilogo articoli</label><textarea rows="4" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="Es. 1x Body Aurora rosa taglia 10 con nome Sofia stampato sulla schiena..." /></div>
        </div>
      </Modal>
    </Layout>
  );
}
